import { Trans, useTranslation } from 'react-i18next'
import AssignedBySlug from '../slugs/AssignedBySlug'
import React from 'react'
import { LearningItem } from '../../models/LearningItem'

export default function CourseAssignments({ learningItem }: { learningItem: LearningItem }) {
  const { t } = useTranslation()

  return (
    learningItem.userLearningAssignments &&
    learningItem.userLearningAssignments?.length > 0 &&
    learningItem.userLearningAssignments?.map((userAssignment) => {
      return (
        <div key={`${userAssignment.uuid}`}>
          {!!userAssignment.dueDate && (
            <Trans t={t} i18nKey="learning item.assigned {at} <by> {till}">
              <AssignedBySlug assignment={userAssignment} />
              {{ at: userAssignment.createdAt }}
              {{ till: userAssignment.dueDate }}
            </Trans>
          )}
          {!userAssignment.dueDate && (
            <Trans t={t} i18nKey="learning item.assigned {at} <by>">
              <AssignedBySlug assignment={userAssignment} />
              {{ at: userAssignment.createdAt }}
            </Trans>
          )}
        </div>
      )
    })
  )
}
